module.exports = {"540103100":"东嘎镇","540103101":"乃琼镇","540103200":"羊达乡","540103201":"古荣乡","540103202":"柳梧乡","540103203":"马乡","540103204":"德庆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540103.json
// module id = 2483
// module chunks = 0